import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  Route,
} from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    let url: string = state.url;

    return await this.checkLogin(url);
  }

  async canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return await this.canActivate(route, state);
  }


  /**
   * Dado un pedido de URL valida que este logueado. Si esta ya logueado lo deja pasar a la URL requerida;
   *  de lo contrario lo envia a la pagina de login
   * 
   * @param url 
   */
  async checkLogin(url: string) {
    console.log("se comienza a chequear login")
    if (this.authService.isLoggedIn 
      ) {
      console.log("se termina de chequear login")
      return true;
    } else {
      // Store the attempted URL for redirecting
      this.authService.redirectUrl = url;

      // Navigate to the login page with extras
      this.router.navigate(["/login"]);
      return false;
    }

  }

}
